import './App.css';
import { Routes, Route } from "react-router-dom"
import Physics from './Pages/Physics';
import Maths from './Pages/Maths';
import Home from './Pages/Home';
import BasicElectricalEngineering from './Pages/BasicElectricalEngineering';
import EngineeringVisualization from './Pages/EngineeringVisualization';
import English from './Pages/English';
import InnovationDesignThinking from './Pages/InnovationDesignThinking';
import Civil from './Pages/Civil';
import Contact from './Pages/Contact';
import Notes from './Pages/Notes';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={ <Home /> } />
        <Route path="contact" element={ <Contact /> } />
        <Route path="physics" element={ <Physics /> } />
        <Route path="maths" element={ <Maths /> } />
        <Route path="basicelectricalengineering" element={ <BasicElectricalEngineering /> } />
        <Route path="civil" element={ <Civil /> } />
        <Route path="engineeringvisualization" element={ <EngineeringVisualization /> } />
        <Route path="english" element={ <English /> } />
        <Route path="innovationdesignthinking" element={ <InnovationDesignThinking /> } />
        <Route path='file/:subject/:src' element={ <Notes /> } />
      </Routes>
    </div>
  );
}

export default App;
